export enum SixthBodyEnum {
  FEMALE = 12,
  MALE = 11,
}
